import React from 'react';
import qwest from 'qwest';
import jwtDecode from 'jwt-decode';

let _token;

function getToken() {
  if (_token) {
    return _token;
  }

  return _token = new URLSearchParams(window.location.search).get('token');
}

export function getTokenData() {
  const token = getToken();

  if (!token) {
    return {};
  }

  return jwtDecode(token);
}

export function getData() {
  const linkurl = window.URL;

  const token = getToken();
  const proto = linkurl.indexOf('PrintData') !== -1 ? 'https://' : 'http://';
  const url = proto + linkurl + '?token=' + token;

  return qwest.get(url);
}
